import { faker } from '@faker-js/faker';

import type { ReferralsPostResponse } from '../types/ReferralsPostResponse';

export function createReferralsPostResponse(
  data: NonNullable<Partial<ReferralsPostResponse>> = {}
): NonNullable<ReferralsPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
